<p-toast position="bottom-center"></p-toast>

<div class="card md-form-shell">
  <form
    [formGroup]="itemForm"
    novalidate
    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    spellcheck="off"
    (ngSubmit)="saveItem()"
  >
    <div class="card-container bg-gray-100 border-round mt-2 p-4">
      <div class="mr-5 flex align-items-center mb-3">
        <i class="pi pi-file-edit mr-2 text-3xl"></i>
        <div class="font-medium text-3xl text-900">{{ pageTitle }}</div>
      </div>

      <div class="grid formgrid p-fluid">
        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                type="text"
                formControlName="erpItemId"
                id="erpItemId"
                class="w-full"
                readonly
              />
              <label for="erpItemId">Item ID</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                type="text"
                formControlName="erpItemNumber"
                id="erpItemNumber"
                class="w-full"
                readonly
              />
              <label for="erpItemNumber">Item Number</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-align-right"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                type="text"
                formControlName="erpItemNameA"
                id="erpItemNameA"
                class="w-full"
                readonly
              />
              <label for="erpItemNameA">Item Name Arabic</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-align-left"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                type="text"
                formControlName="erpItemNameE"
                id="erpItemNameE"
                class="w-full"
                readonly
              />
              <label for="erpItemNameE">Item Name English</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-box"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                type="text"
                formControlName="erpItemUom"
                id="erpItemUom"
                class="w-full"
                readonly
              />
              <label for="erpItemUom">Item UOM</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-book"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                type="text"
                formControlName="erpVendorCatalog"
                id="erpVendorCatalog"
                class="w-full"
                readonly
              />
              <label for="erpVendorCatalog">Item Catalog</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-flag"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                type="text"
                formControlName="erpItemStatus"
                id="erpItemStatus"
                class="w-full"
                readonly
              />
              <label for="erpItemStatus">Item Status</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <app-entity-dropdown-picker
          formControlName="brand"
          [adapter]="brandPickerAdapter"
          inputId="brand"
          label="Brand"
          placeholder="Select a Brand"
          filterPlaceholder="Filter brands"
          columnClass="col-12 md:col-6"
          addonIconClass="pi pi-tags"
        ></app-entity-dropdown-picker>
        <app-entity-dropdown-picker
          formControlName="subBrand"
          [adapter]="subBrandPickerAdapter"
          inputId="subBrand"
          label="Sub Brand"
          placeholder="Select a Sub Brand"
          filterPlaceholder="Filter sub brands"
          columnClass="col-12 md:col-6"
          addonIconClass="pi pi-sitemap"
        ></app-entity-dropdown-picker>
        <app-entity-dropdown-picker
          formControlName="category"
          [adapter]="categoryPickerAdapter"
          inputId="category"
          label="Category"
          placeholder="Select a Category"
          filterPlaceholder="Filter categories"
          columnClass="col-12 md:col-6"
          addonIconClass="pi pi-folder"
        ></app-entity-dropdown-picker>

        <app-entity-dropdown-picker
          formControlName="subCategory"
          [adapter]="subCategoryPickerAdapter"
          inputId="subCategory"
          label="Sub Category"
          placeholder="Select a Sub Category"
          filterPlaceholder="Filter sub categories"
          columnClass="col-12 md:col-6"
          addonIconClass="pi pi-folder-open"
        ></app-entity-dropdown-picker>

        <app-entity-dropdown-picker
          formControlName="supplier"
          [adapter]="supplierPickerAdapter"
          inputId="supplier"
          label="Supplier"
          placeholder="Select a Supplier"
          filterPlaceholder="Filter suppliers"
          columnClass="col-12 md:col-6"
          addonIconClass="pi pi-truck"
        ></app-entity-dropdown-picker>

        <app-entity-dropdown-picker
          formControlName="supplierSite"
          [adapter]="supplierSitePickerAdapter"
          inputId="supplierSite"
          label="Supplier Site"
          placeholder="Select a Supplier Site"
          filterPlaceholder="Filter supplier sites"
          columnClass="col-12 md:col-6"
          addonIconClass="pi pi-map-marker"
        ></app-entity-dropdown-picker>

        <app-entity-dropdown-picker
          formControlName="business"
          [adapter]="businessPickerAdapter"
          inputId="business"
          label="Business"
          placeholder="Select a Business"
          filterPlaceholder="Filter businesses"
          columnClass="col-12 md:col-6"
          addonIconClass="pi pi-building"
        ></app-entity-dropdown-picker>
      </div>
    </div>
      <!-- Actions -->
      <div class="mt-4 flex justify-content-end gap-2">
        <p-button
          label="Cancel"
          styleClass="p-button-secondary"
          type="button"
          (onClick)="cancel()"
        ></p-button>
        <p-button
          [label]="isEditMode ? 'Update Item' : 'Save Item'"
          type="submit"
          [disabled]="itemForm.invalid"
        ></p-button>
      </div>
  </form>
</div>
